import type { FC } from "react";

import InfoCircle from "./icons/InfoCircle";

import * as css from "./IconWithBalloon.module.css";

export interface IIconWithBalloon {
    position: IconWithBalloonPosition;
    message: string;
}

export enum IconWithBalloonPosition {
    Top,
    TopLeft,
    Right,
    Bottom,
    Left,
}

const getPosition = (align: IconWithBalloonPosition) => {
    switch (align) {
        case IconWithBalloonPosition.Top:
            return css.alignTop;
        case IconWithBalloonPosition.TopLeft:
            return css.alignTopLeft;
        case IconWithBalloonPosition.Right:
            return css.alignRight;
        case IconWithBalloonPosition.Bottom:
            return css.alignBottom;
        case IconWithBalloonPosition.Left:
        default:
            return css.alignLeft;
    }
};

const IconWithBalloon: FC<IIconWithBalloon> = ({ message, position }) => (
    <div className={css.iconWithBalloonComponent}>
        <div className={`${css.icon} ${getPosition(position)}`} aria-label={message}>
            <InfoCircle />
        </div>
    </div>
);

export default IconWithBalloon;
